import { useCallback, useRef } from 'react';
import { pick } from 'ramda';
import { batch } from 'react-redux';

import * as helpers from '../helpers';
import * as actions from '../store/actions';
import { useDynamicReducerSelector, useDynamicReducerDispatch } from '../store';

export const useShiftCarouselPosition = (container: HTMLDivElement | null) => {
    const dispatch = useDynamicReducerDispatch();
    const animateFrameRef = useRef<number | null>(null);
    const {
        activeSlide, itemWidth, prevSlide, slidesCount, direction, restart,
        containerShift: storeContainerShift, config: { loop, itemsPerView, gap, tailWidth }
    } = useDynamicReducerSelector(pick([
        'activeSlide', 'itemWidth', 'prevSlide', 'slidesCount',
        'direction', 'restart', 'containerShift', 'config'
    ]));

    return useCallback(() => {
        animateFrameRef.current && window.cancelAnimationFrame(animateFrameRef.current);
        animateFrameRef.current = null;

        if (!container || !itemWidth) {
            return;
        }

        animateFrameRef.current = window.requestAnimationFrame(() => {
            const containerShift = helpers.getContainerShift({
                container, storeContainerShift, prevSlide, activeSlide,
                itemsPerView, gap, loop, slidesCount,
                tailWidth, itemWidth, direction
            });
            const itemShift = helpers.getItemShift({
                container, loop, activeSlide, itemWidth,
                itemsPerView, gap, containerShift, slidesCount
            });

            batch(() => {
                dispatch(actions.updateContainerShift(containerShift));
                dispatch(actions.updateItemShift(itemShift));
            });

            if (!restart) {
                container.classList.add('animating');
            }
        });
    }, [
        container, prevSlide, activeSlide, itemWidth, gap, dispatch, restart,
        tailWidth, itemsPerView, loop, slidesCount, direction, storeContainerShift
    ]);
};
